// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { AddRoleComponent } from 'src/app/modules/roles/pages/add-role/add-role.page';
import { RoleDetailComponent } from 'src/app/modules/roles/pages/role-detail/role-detail.page';
import { RolesListComponent } from 'src/app/modules/roles/pages/roles-list/roles-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: RolesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadRolesList']
    },
  },
  {
    path: 'detail/:roleId',
    component: RoleDetailComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateRoles']
    },
  },
  {
    path: 'add',
    component: AddRoleComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canCreateRoles']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class RolesRoutingModule { }
